<template>
  <section class="testimonials-section section">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">客户见证</h2>
        <p class="section-subtitle">信任来源于专业与实力</p>
      </div>
      
      <div class="testimonials-slider">
        <div class="testimonial-card neumorphic-card" v-for="(testimonial, index) in testimonials" :key="index">
          <div class="testimonial-content">
            <div class="testimonial-stars">
              <i class="fas fa-star" v-for="n in 5" :key="n"></i>
            </div>
            <p class="testimonial-text">{{ testimonial.text }}</p>
          </div>
          <div class="testimonial-author">
            <div class="author-avatar" :style="{ backgroundColor: testimonial.avatarColor }">
              {{ testimonial.initials }}
            </div>
            <div class="author-info">
              <h4 class="author-name">{{ testimonial.name }}</h4>
              <p class="author-position">{{ testimonial.position }}</p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="testimonials-brands">
        <div class="brand-title">我们的合作伙伴</div>
        <div class="brands-grid">
          <div class="brand-logo" v-for="(brand, index) in brands" :key="index">
            {{ brand }}
          </div>
        </div>
      </div>
      
      <!-- 添加浮动粒子 -->
      <div class="particles">
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
        <div class="particle"></div>
      </div>
    </div>
    
    <div class="section-background">
      <div class="gradient-circle circle-1"></div>
      <div class="gradient-circle circle-2"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TestimonialsSection',
  data() {
    return {
      testimonials: [
        {
          text: "弦动魔方团队为我们定制的AI模型训练方案大大提升了我们的业务处理效率，他们的专业水平和服务态度都非常出色。",
          name: "张总",
          position: "湖南某科技公司CTO",
          initials: "张",
          avatarColor: "#9D6EFD"
        },
        {
          text: "我们与弦动魔方的合作非常愉快，他们的AIGC平台帮助我们解决了内容创作的瓶颈，极大地提高了工作效率。",
          name: "李总",
          position: "教育培训机构负责人",
          initials: "李",
          avatarColor: "#E879F9"
        },
        {
          text: "弦动魔方开发的智能硬件产品质量过硬，功能丰富，完全符合我们的预期，满足了我们日常运营的需求。",
          name: "王经理",
          position: "零售连锁企业经理",
          initials: "王",
          avatarColor: "#8B5CF6"
        }
      ],
      brands: [
        "湖南工业大学", "哈尔滨工程大学", "武汉理工大学", "湖南工商大学", "湖南工程学院", "湖南企业联盟"
      ]
    }
  },
  mounted() {
    // 为卡片添加索引以实现交错动画
    const cards = document.querySelectorAll('.testimonial-card');
    cards.forEach((card, index) => {
      card.style.setProperty('--index', index);
    });
    
    // 为品牌logo添加索引
    const logos = document.querySelectorAll('.brand-logo');
    logos.forEach((logo, index) => {
      logo.style.setProperty('--index', index);
    });
  }
}
</script>

<style scoped>
.testimonials-section {
  position: relative;
  background-color: var(--bg-darker);
  overflow: hidden;
  padding: 6rem 0;
  perspective: 1000px;
}

.section-header {
  animation: fadeInUp 0.8s ease-out forwards;
}

.testimonials-slider {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
  position: relative;
  z-index: 1;
  transform-style: preserve-3d;
}

.testimonial-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--bg-card);
  border-radius: var(--border-radius-lg);
  padding: 2rem;
  height: 100%;
  border: 1px solid rgba(157, 110, 253, 0.2);
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transform-style: preserve-3d;
  perspective: 1000px;
  transform: translateZ(0) rotateX(0) rotateY(0);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  animation: cardFloat 1s ease-out forwards;
  animation-delay: calc(var(--index, 0) * 0.2s);
}

@keyframes cardFloat {
  0% {
    opacity: 0;
    transform: translateY(50px) translateZ(-50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0) translateZ(0);
  }
}

.testimonial-card:hover {
  transform: translateY(-15px) rotateX(5deg) rotateY(-5deg) translateZ(20px);
  box-shadow: 0 15px 35px rgba(157, 110, 253, 0.3), 0 5px 15px rgba(0, 0, 0, 0.2);
  border-color: var(--primary-color);
  z-index: 2;
}

.testimonial-content {
  position: relative;
  z-index: 1;
  transform: translateZ(20px);
}

.testimonial-stars {
  color: var(--primary-color);
  margin-bottom: 1rem;
  display: flex;
  gap: 0.25rem;
  animation: starPulse 3s infinite alternate;
}

@keyframes starPulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1.1);
    opacity: 1;
  }
}

.testimonial-text {
  font-size: 1rem;
  line-height: 1.7;
  color: var(--text-secondary);
  margin-bottom: 2rem;
  position: relative;
  transition: all 0.3s ease;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
  transform: translateZ(30px);
  transition: all 0.5s ease;
}

.author-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  flex-shrink: 0;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  animation: pulse 3s infinite alternate;
}

@keyframes pulse {
  0% {
    transform: scale(1) translateZ(0);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }
  100% {
    transform: scale(1.05) translateZ(10px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
  }
}

/* 浮动背景粒子 */
.particles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.particle {
  position: absolute;
  width: 6px;
  height: 6px;
  background: var(--primary-color);
  border-radius: 50%;
  opacity: 0.2;
  animation: particleFloat 15s linear infinite;
}

.particle:nth-child(1) { top: 10%; left: 10%; animation-duration: 20s; width: 8px; height: 8px; }
.particle:nth-child(2) { top: 30%; left: 30%; animation-duration: 25s; animation-delay: 2s; }
.particle:nth-child(3) { top: 70%; left: 60%; animation-duration: 18s; width: 10px; height: 10px; }
.particle:nth-child(4) { top: 40%; left: 80%; animation-duration: 22s; animation-delay: 5s; }
.particle:nth-child(5) { top: 80%; left: 20%; animation-duration: 28s; width: 7px; height: 7px; }

@keyframes particleFloat {
  0% {
    transform: translateY(0) translateX(0);
    opacity: 0.2;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    transform: translateY(-100px) translateX(100px);
    opacity: 0.2;
  }
}

.brands-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 2rem;
  align-items: center;
  margin-top: 2rem;
  perspective: 1000px;
  transform-style: preserve-3d;
}

.brand-logo {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-light);
  font-weight: 600;
  opacity: 0.7;
  transition: all 0.5s ease;
  transform: translateZ(0px);
  animation: logoFloat 3s ease-in-out infinite alternate;
  animation-delay: calc(var(--index, 0) * 0.5s);
}

@keyframes logoFloat {
  0% {
    transform: translateY(0) translateZ(0px);
  }
  100% {
    transform: translateY(-10px) translateZ(20px);
  }
}

.brand-logo:hover {
  opacity: 1;
  transform: translateY(-5px) translateZ(30px);
  text-shadow: 0 5px 15px rgba(157, 110, 253, 0.6);
}

.gradient-circle {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.2;
  z-index: 0;
  animation: gradientMove 20s ease-in-out infinite alternate;
  transform-style: preserve-3d;
}

@keyframes gradientMove {
  0% {
    transform: translateX(0) translateY(0) translateZ(-50px);
  }
  100% {
    transform: translateX(50px) translateY(-50px) translateZ(0);
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.testimonials-brands {
  margin-top: 5rem;
  text-align: center;
}

.brand-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 2rem;
  color: var(--text-secondary);
}

@media screen and (max-width: 992px) {
  .testimonials-slider {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .brands-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (max-width: 768px) {
  .testimonials-section {
    padding: 4rem 0;
  }
  
  .testimonials-slider {
    grid-template-columns: 1fr;
  }
  
  .brands-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
}

@media screen and (max-width: 576px) {
  .testimonial-card {
    padding: 1.5rem;
  }
  
  .brands-grid {
    grid-template-columns: 1fr;
  }
}
</style> 